module.exports = __webpack_public_path__ + "static/servicios-782884ea59ac5bfe65c08a6a086fb0d7.jpg";